export default __webpack_public_path__ + "static/Cloud-strategy-28fb97eb2717b62f55d5fb4facd4356f.webp";